import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/services/shared/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
   standalone: true,
  imports: [CommonModule],

})
export class LoaderComponent {

  constructor(private loaderService: LoaderService) { }

  get isLoading(): Subject<boolean> {
    return this.loaderService.isLoading;
  }


}
